export default __webpack_public_path__ + "static/media/6.495b0a76.png";